import React, { useState, useEffect } from "react"
import {
  formatButton,
  formatDetails,
  setBannerCookie,
  checkBannerCookie,
} from "./PromotionBannerMethods"
import useCheckOneTrust from "../../utils/hooks/useCheckOneTrust"
import Cookies from "js-cookie"
import { PromotionBanner } from "trimble-terra"
import { formatLink } from "../../utils/functions"
import Link from "gatsby"

const PromotionBannerConnector = ({ promotionBanner, location, locale, pageContext }) => {
  const {
    updatedAt,
    redisplayDuration,
    header,
    richTextDetails,
    link,
  } = promotionBanner

  //Region: State and cookies
  const [hasDismissedBanner, setHasDismissedBanner] = useState(true)
  const { hasAcceptedOneTrust } = useCheckOneTrust(Cookies)

  // bypass oneTrust (i.e. force "accepted" state) if disable env var set
  const oneTrustAcceptedOrBypassed = process.env.GATSBY_DISABLE_ONETRUST === "true" ? true : hasAcceptedOneTrust;
  const assignedPages = []

  promotionBanner?.page__general?.length > 0 && promotionBanner?.page__general?.map(page => assignedPages?.push(page?.slug));
  promotionBanner?.page_base?.length > 0 && promotionBanner?.page_base?.map(page => assignedPages?.push(page?.slug));
  promotionBanner?.product_page?.length > 0 && promotionBanner?.product_page?.map(page => assignedPages?.push(page?.slug));
  promotionBanner?.blog_article?.length > 0 && promotionBanner?.blog_article?.map(page => assignedPages?.push(page?.slug));

  const { slug } = pageContext;

  useEffect(() => {
    // check if promo banner is linked to a specific page or pages, and only display on those pages
    if(typeof window !== "undefined"){
      if(assignedPages?.length > 0){
        // promo banner has been assigned to specific pages
        if (checkBannerCookie(Cookies, updatedAt)) {
          // if cookie exists, banner has been dismissed previously
          setHasDismissedBanner(true)
        } else if (assignedPages.includes(slug)){
          // if current page has an assigned promotion banner
          setHasDismissedBanner(false)
        }
      } else {
        // promo banner should be site-wide
        if (checkBannerCookie(Cookies, updatedAt)) {
          // if cookie exists, banner has been dismissed previously
          setHasDismissedBanner(true)
        } else {
          setHasDismissedBanner(false)
        }
      }
    }
  }, [pageContext, updatedAt])

  const handleDismiss = () => {
    //When the user dismisses the overlay, set a cookie ...
    //so that we can check if the user has dismissed the overlay on future visits
    setBannerCookie(Cookies, updatedAt, redisplayDuration)
    setHasDismissedBanner(true)
  }

  const promotionLink = {
      destination: formatLink(
        link?.linkUrl || link?.url || link?.dynamicPageReference?.url,
        locale,
        link?.__typename,
        // homepageSlug
      ),
      label: link?.text || link?.title || link?.linkText,
      type: "link",
      Link: link?.__typename === "ContentfulExternalLink" ? null : Link
    }

  //End Region: State and cookies

  //Region: Format content

  const formattedDetails = formatDetails(richTextDetails, location)
  return (
    (hasDismissedBanner === false) && (
      <PromotionBanner
        header={header}
        cta={promotionLink}
        details={formattedDetails}
        handleClose={handleDismiss}
        hasAcceptedOneTrust={oneTrustAcceptedOrBypassed}
        hasDismissedBanner={hasDismissedBanner}
      />
    )
  )
}

export default PromotionBannerConnector
